/**
 * Created by ronmarsiano on 09/04/2018.
 */
mainApp.directive('keepAlive', function() {
    return {
        templateUrl: '/public/directives/keepAlive.html',
        scope: {
            site: '='
        },
        controller:  ['$scope', '$timeout', '$state' , function($scope, $timeout, $state) {

            var FIXED_SOURCE_IP = '10.254.254.1';

            $scope.$watch('site.keepAliveEnabled', function(newVal, oldVal){
                // meaning keep alive has been turned on
                if(!angular.equals(newVal,oldVal)){
                    if(newVal){
                        // meaning that we want to auto populate with 10.254.254.1
                        if(!$scope.site.keepAliveSourceIp && $scope.site.siteConnType && $scope.site.siteConnType.supportKeepAlive){
                            $scope.site.keepAliveSourceIp = FIXED_SOURCE_IP;
                        }

                        // populating with site native gateway
                        if(!$scope.site.keepAliveDestinationIp && $scope.site.interfaces && $scope.site.interfaces[0] && $scope.site.interfaces[0].gateway &&
                            $scope.site.interfaces[0].gateway.subnet){
                            $scope.site.keepAliveDestinationIp = $scope.site.interfaces[0].gateway.subnet;
                        }

                        // populating interval with 5
                        if(!$scope.site.keepAliveInterval){
                            $scope.site.keepAliveInterval = 5;
                        }
                    }
                    else {
                        // setting the default value to 5
                        if ($scope.site.keepAliveInterval) {
                            $scope.site.keepAliveInterval = 5;
                        }
                        // removing the keep alive destination ip
                        if ($scope.site.keepAliveDestinationIp) {
                            delete $scope.site.keepAliveDestinationIp;
                        }
                        // removing the keep alive source ip
                        if ($scope.site.keepAliveSourceIp) {
                            delete $scope.site.keepAliveSourceIp;
                        }
                    }
                }
            });
        }]
    }
});